import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import UserController from "./controller/UserController";
import APIController from "./controller/APIController";
import AuthPage from './pages/user/AuthPage';
import AuthMenu from './pages/user/AuthMenu';
import config from "./config";
import DatenschutzPage from "./pages/pageComponents/DatenschutzPage";
import AGBPage from "./pages/pageComponents/AGBPage";
import WorksheetPrintViewComponent from "./components/WorksheetPrintViewComponent";

const root = ReactDOM.createRoot(document.getElementById('root'));

    /*
    * Redirect Layer (Legacy URL Compatibility)
    *
    * Diese Weiterleitungen existieren als temporäre Kompatibilitätsschicht,
    * da frühere Kommunikationskanäle (E-Mails, PDF-Ausdrucke im Uniplus-System,
    * sowie externe Teilnehmerunterlagen) noch alte URLs enthalten.
    *
    * Insbesondere betroffen sind Login-, Aktivierungs-, Passwort-vergessen-
    * sowie TAN-Links, die ursprünglich unter der Domain
    * my.ausbildung.cloud kommuniziert wurden.
    *
    * Da die Plattform auf my.bauabc.de migriert wurde, stellen diese Redirects
    * sicher, dass bestehende Links weiterhin funktionieren und keine Teilnehmer
    * durch veraltete Bookmarks oder Dokumente ins Leere laufen.
    *
    * Diese Lösung ist bewusst als temporär anzusehen.
    * Sobald die alten URLs in allen Kommunikationskanälen vollständig ersetzt
    * wurden (geschätzt in 1–2 Jahren), können diese Redirects entfernt werden.
    *
    * Hinweis:
    * Die TAN-Weiterleitung ist zusätzlich notwendig, da TANs Sonderzeichen
    * enthalten können (z. B. ?, &, /), die im Query-String problematisch sind.
    * Daher erfolgt die Übergabe über den Path und wird anschließend sauber
    * URL-encoded weitergeleitet.
    */
    if(window.location.pathname === "/neuespasswort"){
        window.location = config.TEILNEHMERPORTAL_URL+"/start/passwort-vergessen";
    }else if(window.location.pathname === "/logout"){
        try{
            let microsoftLogout = false;
            if(UserController.isInstructor() || UserController.isInstructorAdmin()){
                microsoftLogout = true;
            }
            APIController.logoutSessionUser();
            UserController.logout();

            if(microsoftLogout){
                window.location = 'https://login.microsoftonline.com/e48cfed5-edc8-4ab5-a9f7-9cb31f72a6b0/oauth2/v2.0/logout'
            }else{
                window.location.href = "/";
            }
        }catch(e){
            
        }
    }else if(window.location.pathname === "/login"){
        window.location = config.APP_HOST_URL;
    }else if(window.location.pathname === "/aktivieren"){
        window.location = config.TEILNEHMERPORTAL_URL+"/start";
    }else if (window.location.pathname.substring(0,5) === "/tan/") {
        /*
        * Special TAN-URL Encoder + Forwarder
        * This function solves the problem that some tans have special characters like '?,&,/'.
        * These characters make problems because the URL https://my.ausbildung.cloud/aktivieren?tan=GDH%26ZZ
        * would be invalid because of '&' character, which breaks the string value tan.
        * The solution is, parsing not the query param but path string:
        * https://my.ausbildung.cloud/tan/GDH%26ZZ now redirects to http://localhost:3000/aktivieren?tan=GDH%26ZZ.
        * The '&' character is first encoded and then added as normal encoded URI query param.
        */
        let domain = window.location.toString().split('/tan/')[0];
        let tan = window.location.toString().split('/tan/')[1];
        let decodedTanValue = tan;
        try {
            decodedTanValue = decodeURIComponent(tan);
        } catch {}
        decodedTanValue = decodedTanValue.replace(' ','+');//specialcase for empty space character
        let encodedTanValue = encodeURIComponent(decodedTanValue);
        let activateUlrWithEncodedTan = config.TEILNEHMERPORTAL_URL+"/start?tan="+encodedTanValue;
        //redirect to http://{domain}/aktivieren?tan={encodedTanValue}
        window.location = activateUlrWithEncodedTan;
    }else if(window.location.pathname === "/datenschutz"){
        root.render(
                <React.StrictMode>
                    <DatenschutzPage />
                </React.StrictMode>
            )
    }else if(window.location.pathname === "/agb"){
        root.render(
                <React.StrictMode>
                    <AGBPage />
                </React.StrictMode>
            )
    }else if(window.location.pathname === "/pdf"){
        const urlParams = new URLSearchParams(window.location.search);
        const worksheetId = encodeURIComponent(urlParams.get('id'));
        const token = urlParams.get('token');
        if(token !== config.PRADLE_PDF_EXPORT_TOKEN){
            root.render(<div className={'WorksheetPrintViewComponent'}><span>this is not allowed</span></div>)
        }else{
            root.render(
                <React.StrictMode>
                        <WorksheetPrintViewComponent worksheetId={worksheetId} />
                </React.StrictMode>
            )
        }
    }else{
       (async () => {
            try{
                let user = await APIController.getSessionUser();
                if(!user) {
                    user = await APIController.getUserProfile();
                }
                UserController.loginLocalUser(user, false);
            
                const refreshInterval = 120 * 1000; // Alle 2 Minuten
                const intervalId = setInterval(async () => {
                    try {
                        await APIController.refreshSessionUser();
                    } catch (e) {
                        window.alert("Login Sitzung abgelaufen. Bitte erneut einloggen.")
                        UserController.logout();
                        clearInterval(intervalId); // stoppt weitere Versuche
                        window.location.reload();
                    }
                }, refreshInterval);        
                root.render(
                    <React.StrictMode>
                        <App />
                    </React.StrictMode>
                );
            }catch(e){
                    window.alert("Login Sitzung abgelaufen. Bitte von vorne starten.")
                    UserController.logout();
                    root.render(
                    <React.StrictMode>
                        <App />
                    </React.StrictMode>
                );
            }
        })();
    }







// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
